import { Space } from '@gousto-internal/citrus-react'
import {
  clickClaimDiscountPopup,
  clickCloseDiscountFailurePopup,
  clickCloseDiscountPopup,
  clickEnterPromoCodeManuallyButton,
} from 'actions/trackingKeys'
import { CTA, Modal } from 'goustouicomponents'
import headerImage from 'media/images/discount-modal-header.jpg'
import PropTypes from 'prop-types'
import React from 'react'
import { browserHistory } from 'react-router'
import { signupConfig } from 'routes/Signup/signupConfig'
import { AgeVerifyContainer } from './AgeVerify'
import { EnterPromoCodeManuallyButton } from './EnterPromoCodeManuallyButton'
import css from './PromoModal.css'

const PromoModal = ({
  error,
  promoApply,
  justApplied,
  closeModal,
  trackUTMAndPromoCode,
  basketPromoCodeChange,
  promoClear,
  modalTextContent,
  title,
  needsAgeVerification,
  isAgeVerified,
  buttonText,
  pending,
}) => {
  const handleClick = (type) => () => {
    if (error || justApplied) {
      const event = error ? clickCloseDiscountFailurePopup : clickCloseDiscountPopup
      trackUTMAndPromoCode(event)
      if (!justApplied) {
        basketPromoCodeChange('')
      }

      return closeModal()
    } else {
      const eventType = type === 'close' ? clickCloseDiscountPopup : clickClaimDiscountPopup
      trackUTMAndPromoCode(eventType)

      return promoApply()
    }
  }

  const handleEnterPromoCodeManuallyClick = () => {
    trackUTMAndPromoCode(clickEnterPromoCodeManuallyButton)
    promoClear()
    closeModal()
    browserHistory.push(`/signup/${signupConfig.enterPromoCodeManuallyPageSlug}`)
  }

  return (
    <div className={css.hideScroll} data-testing="promoModal">
      <Modal
        isOpen
        variant="floating"
        name="promo-modal"
        description="promo code modal"
        handleClose={handleClick('close')}
      >
        <div className={css.container} data-testing="promoModal">
          {!error && (
          <img className={css.header} src={headerImage} alt="Enjoy a tasty offer on us" />
          )}
          {error && <h4 className={css.errorSubHeader}>{title}</h4>}
          <div className={css.contentContainer}>
            {!error && <h4 className={css.subHeader}>{title}</h4>}
            {modalTextContent}
            <Space size={3} />
            {needsAgeVerification && !error ? <AgeVerifyContainer /> : null}
            <CTA
              size="medium"
              testingSelector="promoModalButton"
              onClick={handleClick('claimDiscount')}
              variant="primary"
              isFullWidth
              disabled={(needsAgeVerification && !isAgeVerified && !error) || pending}
            >
              {buttonText}
            </CTA>
            <EnterPromoCodeManuallyButton onClick={handleEnterPromoCodeManuallyClick} />
          </div>
        </div>
      </Modal>
    </div>
  )
}

PromoModal.propTypes = {
  modalTextContent: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  error: PropTypes.string,
  promoApply: PropTypes.func,
  needsAgeVerification: PropTypes.bool,
  isAgeVerified: PropTypes.bool,
  buttonText: PropTypes.string.isRequired,
  pending: PropTypes.bool,
  justApplied: PropTypes.bool,
  trackUTMAndPromoCode: PropTypes.func,
  closeModal: PropTypes.func.isRequired,
  basketPromoCodeChange: PropTypes.func,
  promoClear: PropTypes.func,
}

PromoModal.defaultProps = {
  promoApply: () => {},
  needsAgeVerification: false,
  isAgeVerified: false,
  pending: false,
  justApplied: false,
  trackUTMAndPromoCode: () => {},
  error: '',
  basketPromoCodeChange: () => {},
  promoClear: () => {}
}

export { PromoModal }
